import ShareBanner from '@/scripts/Components/Molecules/ShareBanner';

const VSChannelEditions = function VSChannelEditions() {};
VSChannelEditions.prototype.init = function init() {
  return {
    components: {
      ShareBanner,
    },
  };
};

export default new VSChannelEditions();
